import Hero from '../sections/Hero'
import Vision from '../sections/Vision'
import Showcase from '../sections/Showcase'
import PersonalityMemory from '../sections/PersonalityMemory'
import HowItWorks from '../sections/HowItWorks'
import AgentsPlan from '../sections/AgentsPlan'
import Roadmap from '../sections/Roadmap'
import Principles from '../sections/Principles'
import CallToAction from '../sections/CallToAction'

export default function HomePage() {
  return (
    <main>
      <Hero />
      <Vision />
      <Showcase />
      <PersonalityMemory />
      <HowItWorks />
      <AgentsPlan />
      <Roadmap />
      <Principles />
      <CallToAction />
    </main>
  )
}
